import ErrorModal from './container'

export default ErrorModal
